import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('studentinfo').select().eq('companyId', companyId)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('studentinfo').select().eq('type', type).eq('companyId', companyId)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('studentinfo').select().eq('id', id)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('studentinfo').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('studentinfo').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('studentinfo').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
